
import "../../css/PlatformPage.css";


import React, { useEffect, useState } from "react";

import { Header } from "../../common/Header";

import { fromCamelCaseToCapitalizedSpaced, toKebabCase } from "../../utilities/helpers";




enum BusinessPageType { // TODO: Move to Shared Repo ??
    PRIVACY_POLICY = "privacyPolicy",
    TERMS_OF_USE = "termsOfUse",
    ABOUT_US = "aboutUs",
}



interface BusinessPageProps {
    businessPageType: string;
}

const BusinessPage: React.FC<BusinessPageProps> = ( { businessPageType } ) => {

    const [content, setContent] = useState<string>("");

    const pageNameCapitalizedSpace = fromCamelCaseToCapitalizedSpaced( businessPageType );
    const pageNameKebab = toKebabCase( businessPageType );
    

    useEffect(() => {

        const fetchContent = async () => {
            const response = await fetch( `/api/v1/content/platform/business/${pageNameKebab}` );

            if (response.ok) {
                const htmlContent = await response.text();
                setContent( htmlContent );
            } else {
                setContent("Error fetching content");
            }
        };

        fetchContent();
    }, []);

    return (
        <>
            <Header content={<HeaderContent businessPageName={pageNameCapitalizedSpace} />} />
            <div className="platform-page" dangerouslySetInnerHTML={{ __html: content }} />
            {/*return <div>{content}</div>;*/}
        </>
    )
};



function HeaderContent( { businessPageName }: { businessPageName: string } ) {

  return (
    <div className="program_header_content_container">
      <div className="program_header_content">
        <h1 className="program_header_content_heading">{businessPageName}</h1>
        <p className="program_header_content_slogan">
          {/*Last Updated: 2024-08-01*/}
        </p>
      </div>
    </div>
  );
}



export {
    BusinessPage,

    BusinessPageType
};
